import { useState } from 'react';
import styles from './HolidayNotice.module.scss';

// Site-wide Obon 2026 notice, mounted once in App.js so it shows on every
// page (login included). Fixed to the bottom of the viewport because the
// app's headers are absolutely-positioned overlays that a top banner would
// collide with. Hides itself starting August 16 in the visitor's local (US)
// time — no redeploy needed to take it down.
const NOTICE_EXPIRES = new Date(2026, 7, 16);
const DISMISS_KEY = 'obon-notice-dismissed-2026';

const HolidayNotice = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed || new Date() >= NOTICE_EXPIRES) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Storage unavailable (private mode): the banner simply returns on the
      // next page load.
    }
  };

  return (
    <div className={styles.holidayNotice} role="status">
      <p>
        <strong>Obon Holiday Notice:</strong> Japan observes its national
        summer holiday August 11&ndash;16. During this period Japanese dealers,
        auction houses, and manufacturers are closed, and any updates that
        depend on the Japan side may be delayed until operations resume
        Monday, August 17. We&rsquo;re still here and answering as normal
        &mdash; thanks for your patience.
      </p>
      <button type="button" aria-label="Dismiss notice" onClick={dismiss}>
        &times;
      </button>
    </div>
  );
};

export default HolidayNotice;
